/* eslint-disable no-useless-escape */
/* eslint-disable max-len */
import { MtmaModule, MtmaModuleSetting } from '../model/mtma-module';

export const MODULE_RFID_KEY_REGEXP = /^[A-Fa-f0-9]+$/;
export const MODULE_AC_NTP_REGEXP = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$|^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)+([A-Za-z]|[A-Za-z][A-Za-z0-9\-]*[A-Za-z0-9])$/u;

export enum MtmaModuleType {
    MTMAC       = 0,
    MTM8C       = 1,
    MTMKB       = 4,
    MTMRFID     = 5,
    MTMDY       = 6,
    MTMINFO     = 7,
    MTMBFVS     = 9,
}

export const 	MTMA_AC_LAYOUT_MTMFA2P = 0;
export const 	MTMA_AC_LAYOUT_MTMFA1P = 1;
export const 	MTMA_AC_LAYOUT_MTMFA0P = 2;
export const 	MTMA_8C_LAYOUT_MTMF8P  = 0;
export const 	MTMA_8C_LAYOUT_MTMF4P  = 1;
export const 	MTMA_8C_LAYOUT_MTMF3P  = 2;
export const 	MTMA_8C_LAYOUT_MTMF2P  = 3;

export const listModuleMtma: MtmaModule[] = [
    { Name: 'MTMAC', Position: 0, Type: 0, Max: 1, Config: {Layout: 0}},
    { Name: 'MTM8C', Position: 0, Type: 1, Max: 12, Config: {Layout: 0}},
    { Name: 'MTMKB', Position: 0, Type: 4, Max: 1},
    { Name: 'MTMRFID', Position: 0, Type: 5, Max: 1},
    { Name: 'MTMDY', Position: 0, Type: 6, Max: 1},
    { Name: 'MTMINFO', Position: 0, Type: 7, Max: 1},
    { Name: 'MTMBFVS', Position: 0, Type: 9, Max: 1},
];

export const LOAD_MODULE: Map<number, number> = new Map<number, number>([
    [0, 0],// 0 main MTMAC
    [1, 1],// 1 buttons MTM8C
    [4, 2],// 4 keypad MTMKB
    [5, 2],// 5 rfid MTMRFID
    [6, 8],// 6 display MTMDY
    [7, 1],// 7 info MTMINFO
    [9, 2],// 9 hearing impaired (audiolesi) MTMBFVS
]);

export const 	MTMA_MAX_LOAD  = 12; // max mtma load, wiout MTMAC


export const mtmacConfig: MtmaModuleSetting[] = [
    {Name: 'TCall', Type: 'int', Min: 1, Max:600, Default: 60, StepSize: 1, DisplayScale: 1.0, Offset: 0},
    {Name: 'TRing', Type: 'int', Min: 1, Max:90, Default: 30, StepSize: 1, DisplayScale: 1.0, Offset: 0},
    {Name: 'TLock', Type: 'int', Min: 1, Max:10, Default: 1, StepSize: 1, DisplayScale: 1.0, Offset: 0},
    {Name: 'TRelay', Type: 'int', Min: 1, Max:3000, Default: 1, StepSize: 1, DisplayScale: 1.0, Offset: 0},
    {Name: 'LedColor', Type: 'intset', Values: [{ Value: 0, Label:'{white}'}, { Value: 1, Label:'{blue}'}], Default: 0},
    {Name: 'LedLevel', Type: 'intset', Values: [{ Value: 0, Label:'{off}'}, { Value: 1, Label:'{very_low}'}, { Value: 2, Label:'{low}'},
        { Value: 3, Label:'{normal}'}, { Value: 4, Label:'{high}'}], Default: 0},
    {Name: 'SpkLevel', Type: 'int', Min: 0, Max:100, Default: 40, StepSize: 5, DisplayScale: 1.0, Offset: 0},
    {Name: 'MicLevel', Type: 'int', Min: 0, Max:15, Default: 10, StepSize: 1, DisplayScale: 1.0, Offset: 0},
    {Name: 'EnTones', Type: 'bits', Values: [{ Value: 0, Label:'{keypad}'}, { Value: 1, Label:'{electric_lock}'}, { Value: 2, Label:'{busy}'}], Default: 0},
    {Name: 'In1Func', Type: 'intset', Values: [{ Value: 0, Label:'{value_0}'}, { Value: 1, Label:'{value_1}'}, { Value: 2, Label:'{value_2}'},
        { Value: 3, Label: '{value_3}'}, { Value: 4, Label:'{value_4}'}], Default: 0},
    {Name: 'Lang', Type: 'intset', Values: [{ Value: 6, Label:'Danish'}, { Value: 7, Label:'German'}, { Value: 9, Label:'English'}, { Value: 10, Label:'Spanish'},
        { Value: 11, Label:'Finnish'}, { Value: 12, Label:'French'}, { Value: 14, Label:'Hungarian'}, { Value: 16, Label:'Italian'}, { Value: 19, Label:'Dutch'}, { Value: 20, Label:'Norwegian'},
        { Value: 21, Label:'Polish'}, { Value: 22, Label:'Portuguese'}, { Value: 25, Label:'Russian'}, { Value: 26, Label:'Croatian'}, { Value: 29, Label:'Swedish'}, { Value: 34, Label:'Ukrainian'},
        { Value: 37, Label:'Estonian'}, { Value: 38, Label:'Latvian'}, { Value: 170, Label:'Jolly'}], Default: 9},
    //{Name: 'Layout', Type: 'intset', Values: [{2: 'MTMFA0P'}, {1: 'MTMFA1P'}, {0: 'MTMFA2P'}], Default: 0},
];


export const mtmDyConfig: MtmaModuleSetting[] =  [
    {Name: 'LcdColor', Type: 'intset', Values: [{ Value: 0, Label:'{white}'}, { Value: 1, Label:'{blue}'}], Default: 0},
    {Name: 'LcdLevel', Type: 'intset', Values: [{ Value: 0, Label:'{off}'}, { Value: 1, Label:'{very_low}'},
        { Value: 2, Label:'{low}'}, { Value: 3, Label:'{normal}'}, { Value: 4, Label:'{high}'}], Default: 0},
    {Name: 'EnStandby', Type: 'bool', Values: [{ Value: 0, Label:'{disable}'}, {Value:  1, Label:'{enable}'}], Default: 0},
    {Name: 'StandbyLevel', Type: 'intset', Values: [{ Value: 0, Label:'{low}'}, {Value: 1, Label:'{high}'}], Default: 0},
    {Name: 'SearchInt', Type: 'int', Min: 1, Max:4, Default: 1, StepSize: 1, DisplayScale: 1.0, Offset: 0},
    {Name: 'SearchIntLimit', Type: 'int', Min: 1, Max:12, Default: 1, StepSize: 1, DisplayScale: 1.0, Offset: 0},
    {Name: 'EnAlphaSearch', Type: 'bool', Values: [{ Value: 0, Label:'{disable}'}, {Value: 1, Label: '{enable}'}], Default: 30, StepSize: 1, DisplayScale: 1.0, Offset: 0},
    {Name: 'Messages', Type: 'strmap', Values: [
        {Name: 'Calling', Value: 'CALLING...'},
        {Name: 'Talk', Value: 'Talk'},
        {Name: 'Error', Value: 'ERROR'},
        {Name: 'Busy', Value: 'BUSY'},
        {Name: 'Privacy', Value: 'Privacy'},
        {Name: 'Wait please', Value: 'Wait please...'},
        {Name: 'Enter please/Door open', Value: 'Enter please'},
        {Name: 'Concierge', Value: 'Concierge'},
        {Name: 'Programming', Value: 'Programming'},
        {Name: 'Row 1', Value: 'Press the '},
        {Name: 'Row 2', Value: 'central key '},
        {Name: 'Row 3', Value: 'and ↑ or ↓ to '},
        {Name: 'Row 4', Value: 'search'},
        {Name: 'Row 5', Value: 'Press ¾ to '},
        {Name: 'Row 6', Value: 'continue or call '},
        {Name: 'Row 7', Value: 'the selected '},
        {Name: 'Row 8', Value: 'extension.'},
        {Name: 'Row 9', Value:  ' '},
        {Name: 'Row 10', Value: 'WELCOME'},
        {Name: 'Row 11', Value:  ''},
        {Name: 'Call Code', Value: 'Call code'},
        {Name: 'Access Code', Value: 'Access code'},
        {Name: 'Language', Value: 'Language'},
        {Name: 'Associate', Value: 'Associate'},
        {Name: 'User', Value: 'user'},
        {Name: 'Correct Code', Value: 'Correct code'},
        {Name: 'Confirm', Value: 'Confirm'},
        {Name: 'Deletion', Value: 'deletion'},
        {Name: 'Back', Value: '← Back'},
        {Name: 'Phonebook', Value: 'Phonebook'},
        {Name: 'Configuration', Value: 'Configuration'},
        {Name: 'Version', Value: 'Version'},
        {Name: 'Display', Value: 'Display'},
        {Name: 'Tones', Value: 'Tones'},
        {Name: 'Password', Value: 'Password'},
        {Name: 'Reset', Value: 'Reset'},
        {Name: 'Contrast', Value: 'Contrast'},
        {Name: 'Backlight', Value: 'Backlight'},
        {Name: 'Colour', Value: 'Colour'},
        {Name: 'Brightness', Value: 'Brightness'},
        {Name: 'Standby', Value: 'Standby'},
        {Name: 'Search intervals', Value: 'Search intervals'},
        {Name: 'Interval limit', Value: 'Interval limit'},
        {Name: 'Information', Value: 'Information'},
        {Name: 'ID', Value: 'ID'},
        {Name: 'Blue text', Value: 'Blue'},
        {Name: 'White text', Value: 'White'},
        {Name: 'Old text', Value: 'Old'},
        {Name: 'New', Value: 'New'},
        {Name: 'Confirm new', Value: 'Confirm new'},
        {Name: 'Change password', Value: 'Change password'},
        {Name: 'Perform reset', Value: 'Perform reset'},
    ]},
    {Name: 'WelcomeMsg', Type: 'strset', Values: ['', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '']}
];

export const MTMA_SECTION_ADD = 'SHOW_SECTION_ADD';
export const MTMA_SECTION_EDIT_MTM_RFID = 'SHOW_SECTION_EDIT_MTM_RFID';
export const MTMA_SECTION_EDIT_MTM_KB = 'SHOW_SECTION_EDIT_MTM_KB';
export const MTMA_SECTION_EDIT_MTM_INFO = 'SHOW_SECTION_EDIT_MTM_INFO';
export const MTMA_SECTION_EDIT_MTM_BFVS= 'SHOW_SECTION_EDIT_MTM_BFVS';
export const MTMA_SECTION_EDIT_MTM_AC = 'SHOW_SECTION_EDIT_MTM_AC';
export const MTMA_SECTION_EDIT_MTM_8C = 'SHOW_SECTION_EDIT_MTM_8C';
export const MTMA_SECTION_EDIT_MTM_DY = 'SHOW_SECTION_EDIT_MTM_DY';
export const MTMA_SECTION_LIST_MTM_RFID = 'SHOW_SECTION_LIST_MTM_RFID';
export const MTMA_SECTION_LIST_MTM_KB = 'SHOW_SECTION_LIST_MTM_KB';

export const MTMACSTD_MINFWVER_PHASEIII = '1.12.002';
export const MTMACUS_MINFWVER_PHASEIII = '1.00.001';